import supabase from '../supabase/supabase';

const CERTIFICATES_TABLE = 'hms_academy_certificates_1715729000000';
const ISSUE_CERTIFICATE_RPC = 'hms_academy_certificate_issue_1715729000000';

const CERTIFICATE_FIELDS = [
  'id',
  'completion_id',
  'certificate_number',
  'issued_at',
  'valid_until',
  'status',
  'learner_display_name',
  'course_title',
  'course_version_title',
  'course_version_version',
  'course_version_language_code',
  'completion_completed_at',
  'issuer_display_name',
  'certificate_display_title'
].join(',');

export async function getCertificateForCompletion(completionId) {
  const { data, error } = await supabase
    .from(CERTIFICATES_TABLE)
    .select(CERTIFICATE_FIELDS)
    .eq('completion_id', completionId)
    .maybeSingle();

  if (error) throw error;
  return data || null;
}

export async function issueCertificate(completionId) {
  const { data, error } = await supabase.rpc(ISSUE_CERTIFICATE_RPC, {
    target_completion_id: completionId
  });

  if (error) throw error;

  const issuance = Array.isArray(data) ? data[0] : data;
  if (!issuance?.certificate_id || !issuance?.verification_secret) {
    throw new Error('Certificate issuance returned no certificate result.');
  }

  const certificate = await getCertificateForCompletion(completionId);
  if (!certificate) {
    throw new Error('Issued certificate was not found during authoritative readback.');
  }

  return { issuance, certificate };
}